export const singleRoomColumns = [
	{
	  title: 'Trial',
	  dataIndex: 'trial',
	  key: 'trial',
	  width: '20%',
	},
	{
	  title: 'Хранение',
	  dataIndex: 'storage',
	  key: 'storage',
	  width: '20%',
	},
	{
	  title: 'Закрытая сделка',
	  dataIndex: 'simple',
	  key: 'simple',
	  width: '20%',
		
	},
	{
	  title: 'Доступ к информации',
	  dataIndex: 'members',
	  key: 'members',
	  width: '20%',
	},
  ];
  
  
  